<template>
  <b-row>
    <b-col cols="4">
      <div class="stat-card">
        <div class="d-flex align-items-center">
          <img alt="total" width="24px" :src="require('@/assets/nuevoDashboard/agenda.svg')" class="mr-2">
          <div>
            <p class="mb-0 valor-stat">{{ totalFilas }}</p>
            <small class="texto-stat">Total filas</small>
          </div>
        </div>
      </div>
    </b-col>
    <b-col cols="4">
      <div class="stat-card stat-card-success">
        <div class="d-flex align-items-center">
          <img alt="success" width="24px" :src="require('@/assets/icons/check-green.svg')" class="mr-2">
          <div>
            <p class="mb-0 valor-stat">{{ filasActualizadas }}</p>
            <small class="texto-stat">Actualizadas</small>
          </div>
        </div>
      </div>
    </b-col>
    <b-col cols="4">
      <div class="stat-card stat-card-error">
        <div class="d-flex align-items-center">
          <img alt="error" width="24px" :src="require('@/assets/icons/close_red.svg')" class="mr-2">
          <div>
            <p class="mb-0 valor-stat">{{ filasConError }}</p>
            <small class="texto-stat">Con error</small>
          </div>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'EstadisticasCarga',
  props: {
    totalFilas: {
      type: Number,
      default: 0
    },
    filasActualizadas: {
      type: Number,
      default: 0
    },
    filasConError: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style scoped>
.stat-card {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  padding: 1.2rem;
  transition: transform 0.2s;
}

.stat-card-success {
  background: #f0f9eb;
  border-color: #c5e29b;
}

.stat-card-error {
  background: #fdf2f2;
  border-color: #f8d7da;
}

.valor-stat {
  font-size: 26px;
  font-weight: 800;
  color: #2c3e50;
  line-height: 1;
}

.texto-stat {
  color: #6c757d;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 10px;
  letter-spacing: 0.5px;
}
</style>